exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".code[data-v-bdd7d0b4] {\n  text-align: center;\n}\n.wx_code_bar[data-v-bdd7d0b4] {\n  width: 100%;\n  height: 250px;\n}\n.wx_code[data-v-bdd7d0b4] {\n  width: 250px;\n  height: 250px;\n}\n.code_text[data-v-bdd7d0b4] {\n  padding: 0 20px;\n  line-height: 22px;\n  text-align: center;\n}\n", ""]);

// exports
